import { getAccessToken } from "../../auth/verifyAuth"

async function initCompletion(msalInstance, variables, contactId, candidature) {
    var accessToken = await getAccessToken(msalInstance, variables);
    let data = {
        contactId: contactId,
        candidature: candidature,
        properties: candidature.properties
    };
    return fetch(window.location.origin + "/api/v2.0/init/", {
        method: "POST",
        headers: {
            "my-Authorization": `Bearer ${accessToken}`,
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    })
}

async function postCompletion(msalInstance, variables, data) {
    var accessToken = await getAccessToken(msalInstance, variables);
    return fetch(window.location.origin + "/api/v2.0/candidatures", {
        method: "POST",
        headers: {
            "my-Authorization": `Bearer ${accessToken}`,
            "Accept": "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
    })
}

async function postFile(msalInstance, variables, file, formId, candidature, contactId, questionId, fileId, templateId, secondaryObjects) {
    var accessToken = await getAccessToken(msalInstance, variables);
    let data = new FormData();
    data.append('file', file);
    data.append('formId', formId);
    data.append('objectAssociated', JSON.stringify(candidature));
    data.append('contactId', contactId);
    data.append('questionId', questionId);
    data.append('oldFileId', fileId);
    data.append('templateId', templateId);
    data.append('objectAssociatedSub', JSON.stringify(secondaryObjects));
    return fetch(window.location.origin + "/api/v1.0/uploadFile", {
        method: "POST",
        headers: {
            "my-Authorization": `Bearer ${accessToken}`
        },
        body: data
    })
}

async function getAllCompletions(msalInstance, variables, objectId, objectType) {
    var accessToken = await getAccessToken(msalInstance, variables);
    let url = window.location.origin + "/api/v2.0/templates";
    if (objectId && objectType) {
        url += "?id=" + objectId + "&object=" + objectType;
    }
    return fetch(url, {
        method: "GET",
        headers: {
            "my-Authorization": `Bearer ${accessToken}`
        }
    }).then(res => {
        if (res.ok) {
            return res.json()
        }
    })
}

async function verifyAddress(msalInstance, variables, queryValue) {
    var accessToken = await getAccessToken(msalInstance, variables);
    return fetch(window.location.origin + "/api/v1.0/verifyaddress?q=" + queryValue, {
        method: "GET",
        headers: {
            "my-Authorization": `Bearer ${accessToken}`
        }
    }).then(res => {
        if (res.ok) {
            return res.json()
        }
    })
}

async function getCityByZipCode(msalInstance, variables, Zipcode) {
    var accessToken = await getAccessToken(msalInstance, variables);
    return fetch(window.location.origin + "/api/v1.0/getcitiesperzipcode/" + Zipcode, {
        method: "GET",
        headers: {
            "my-Authorization": `Bearer ${accessToken}`
        }
    }).then(res => {
        if (res.ok) {
            return res.json()
        }
    })
}

export {
    postCompletion,
    getAllCompletions,
    postFile,
    initCompletion,
    verifyAddress,
    getCityByZipCode
}